import React from 'react';
import { roundUptoDigits } from '../../../../utils/helper';
import LinkProvider from '../../../../CommonComponents/LinkProvider/LinkProvider';
import { removeDomainName } from '../../../../utils/helper';

function RefundAmountBreakup(props) {
  const {
    refundMethodDisplaytext,
    dataLocale,
    totalRefundEstimate,
    fullRefundDetails,
    partialRefundedAmount,
    refundAmount,
    refundAmountLkCashPlus,
    refundAmountLkCash,
    returnConfig,
  } = props; // storeCreditAmount, storeCreditCode,
  const {
    CURRENCY_SYMBOL,
    ALREADY_REFUNDED,
    LK_CASH_PLUS,
    LK_CASH,
    REFUND_METHOD,
    REFUND_DETAILS,
  } = dataLocale; // STORE_CREDIT, PAYU
  const {
    returnSelection: { viewPolicyLink, viewPolicyText },
  } = returnConfig;
  const hasMultipleRefunds = Boolean(
    partialRefundedAmount > 0 ||
      refundAmountLkCash > 0 ||
      refundAmountLkCashPlus > 0 ||
      (fullRefundDetails && fullRefundDetails.length)
  );
  return (
    <React.Fragment>
      <div className="margin-b13 display-flex justify-space-between fs13 fw600">
        <span>{REFUND_DETAILS}</span>
        <LinkProvider
          className="text-color-primary fw600 text-uppercase"
          to={removeDomainName(viewPolicyLink)}
        >
          {viewPolicyText}
        </LinkProvider>
      </div>
      <div className="bg-color_white fw500 text-color_grey_black pd-10 display-flex justify-space-between">
        <div>
          <div className="text-color-grey text-uppercase fs14">{REFUND_METHOD}</div>
          <div className="pd-t5 fs15 fw700 margin-t4">{refundMethodDisplaytext || ''}</div>
        </div>
        <div>
          <div className="text-color-grey text-uppercase fs14">Amount being Refunded</div>
          <div className="pd-t5 fs15 fw700 margin-t4 text-right">
            {CURRENCY_SYMBOL}
            {roundUptoDigits(totalRefundEstimate, 0)}
          </div>
        </div>
      </div>
      {hasMultipleRefunds && (
        <div className="bg-color_white border-bottom pd-10 fs14 order-box bora-8 padding-8 margin-4 margin-t15 padding-r15 padding-l15 fsp14">
          {Boolean(refundAmount > 0 && hasMultipleRefunds) && (
            <div className="display-flex margin-t5 margin-b5 padding-b6 border-bottom justify-space-between">
              <div>{refundMethodDisplaytext}</div>
              <div className="fw700">
                {CURRENCY_SYMBOL}
                {roundUptoDigits(refundAmount, 0)}
              </div>
            </div>
          )}
          {Boolean(fullRefundDetails && fullRefundDetails.length) &&
            fullRefundDetails.map((detail, index) => {
              return (
                <div
                  key={index}
                  className="display-flex margin-t5 margin-b5 padding-b6 border-bottom justify-space-between pd-t10"
                >
                  <div className="text-capitalize">
                    {detail.refundMethodLabel || detail.refundMethod}
                  </div>
                  <div className="fw700">
                    {CURRENCY_SYMBOL}
                    {roundUptoDigits(detail.refundAmount, 0)}
                  </div>
                </div>
              );
            })}
          {Boolean(refundAmountLkCash > 0) && (
            <div className="display-flex margin-t5 margin-b5 padding-b6 border-bottom justify-space-between pd-t10">
              <div>{LK_CASH}</div>
              <div className="fw700">
                {CURRENCY_SYMBOL}
                {roundUptoDigits(refundAmountLkCash, 0)}
              </div>
            </div>
          )}
          {Boolean(refundAmountLkCashPlus > 0) && (
            <div className="display-flex margin-t5 margin-b5 padding-b6 border-bottom justify-space-between pd-t10">
              <div>{LK_CASH_PLUS}</div>
              <div className="fw700">
                {CURRENCY_SYMBOL}
                {roundUptoDigits(refundAmountLkCashPlus, 0)}
              </div>
            </div>
          )}
          {Boolean(partialRefundedAmount > 0) && (
            <div className="display-flex margin-t5 margin-b5 justify-space-between pd-t10">
              <div>{ALREADY_REFUNDED || 'Already Refunded'}</div>
              <div className="fw700">
                {CURRENCY_SYMBOL}
                {roundUptoDigits(partialRefundedAmount, 0)}
              </div>
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
}

export default RefundAmountBreakup;
